import type { PromoCampaignModel } from '@/shared/generated'

import { useState } from 'react'
import { uniqBy } from 'lodash/fp'

import { ampli } from '@/shared/lib/ampli'
import Filter, {
	filterData,
	getFilterValue,
	searchData,
} from '@/shared/tools/page-data-helpers'

export default function useStatusSelect() {
	const [filters, setFilters] = useState<Filter[]>([])
	const addFilter = (filter: Filter) =>
		setFilters(uniqBy('columnId', [filter, ...filters]))
	const handleStatusSelect = (value: boolean | null) => {
		ampli.promoFilterByStatus()
		value != null
			? addFilter(new Filter('is_active', (v: any) => v == value, value))
			: setFilters([])
	}
	const filteringStatus = getFilterValue(filters, 'is_active', null)
	const getFilteredData = (data: PromoCampaignModel[], searchText: string) =>
		filterData(searchData(data || [], searchText, 'name'), filters)

	return {
		filters,
		handleStatusSelect,
		getFilteredData,
		filteringStatus,
	}
}
